/**
 * 管理端  客户管理
 */
 <template>
    <div class="login-page">
      <topInfo></topInfo>
      <agentNav></agentNav>
      <!-- 主体内容 -->

      <!-- 个人资料 -->
      <div class="eval-content">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>个人资料</div>
            <div class="eval-con-btn" style="margin-left: auto;" @click="showEditPsd()">修改密码</div>
         </div>
         <div>
            <el-form :model="adminInfoForm" class="eval-form" label-width="80px" style="padding-bottom: 10px;text-align: left;">
               <div style="display: flex;">
                  <el-form-item label="姓名：" prop="name">
                     <el-input size="small"  v-model.trim="adminInfoForm.name" auto-complete="off" clearable style="width: 450px;" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="领域：" prop="area" style="margin-left: 60px;">
                     <el-input size="small"  v-model.trim="adminInfoForm.area" auto-complete="off" clearable style="width: 450px;" disabled></el-input>
                  </el-form-item>
               </div>
               <div style="display: flex;">
                  <el-form-item label="电话：" prop="mobile">
                     <el-input size="small"  v-model.trim="adminInfoForm.mobile" auto-complete="off" clearable style="width: 450px;" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="邮箱：" prop="email" style="margin-left: 60px;">
                     <el-input size="small"  v-model.trim="adminInfoForm.email" auto-complete="off" clearable style="width: 450px;" disabled></el-input>
                  </el-form-item>
               </div>
               <div style="display: flex;">
                  <el-form-item label="机构：" prop="agency_name">
                     <el-input size="small" v-model.trim="adminInfoForm.agency_name" auto-complete="off" clearable style="width: 450px;" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="职位：" prop="position" style="margin-left: 60px;">
                     <el-input size="small" v-model.trim="adminInfoForm.position" auto-complete="off" clearable style="width: 450px;" disabled></el-input>
                  </el-form-item>
               </div>
            </el-form>
         </div>
      </div>

      <!-- 账户(专家)管理列表 -->
      <div v-if="adminInfoForm.status==2&&adminInfoForm.position=='负责人'" class="eval-content">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>专家管理</div>
            <div class="title-flex-end">
               <div class="eval-con-btn" @click="showEditAgent()">新增专家</div>
               <!-- <div class="eval-con-btn">导入专家</div> -->
               <div class="eval-con-search" style="margin-left: 10px;">
                  <el-input v-model="formInlineAccount.search" placeholder="请输入关键词" clearable>
                     <el-button slot="append" style="color: #ffffff;" @click="searchAgent()">搜索</el-button>
                  </el-input>
               </div>
            </div>
         </div>
         <div class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="accountData" highlight-current-row v-loading="loadAccounting" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="name" align="center" label="姓名" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="mobile" align="center" label="账户(手机号)" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="area" align="center" label="领域" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="position" align="center" label="职位" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="status" align="center" label="状态" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span style="color: #999999;cursor: pointer;" v-if="scope.row.status==1" title="申请恢复专家账户" @click="changeAgentStatus(scope.row,3)">禁用</span>
                     <span style="color: #407AA8;cursor: pointer;" v-if="scope.row.status==2" title="专家已离职,禁用账户" @click="changeAgentStatus(scope.row,1)">正常</span>
                     <span style="color: #F56C6C;cursor: pointer;" v-if="scope.row.status==3" title="等待管理员审核">待审核</span>
                  </template>
               </el-table-column>
               <el-table-column prop="agency_name" align="center" label="机构" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
               </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparmAccount" @callFather="callFatherAccount"></Pagination>
         </div>
      </div>
      <!-- 机构专家案件列表 -->
      <div v-if="adminInfoForm.status==2&&adminInfoForm.position=='负责人'" class="eval-content">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>案件管理</div>
            <div class="title-flex-end">
               <!-- <div class="eval-con-btn" @click="showEditAgent()">新增专家</div> -->
               <!-- <div class="eval-con-btn">导入专家</div> -->
               <div class="areaPicker">
                  <span style="color: #606266;font-size: 14px;">完成时间：</span>
                  <el-date-picker
                        v-model="evalOrderDate"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        format="yyyy.MM.dd"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions">
                  </el-date-picker>
                  <span class="clearBtn" style="margin-left: 4px;" title="清除时间" @click="clearEvalDate()">清除</span>
               </div>
               <div class="eval-con-search" style="margin-left: 10px;">
                  <el-input v-model="formInlineCase.search" placeholder="请输入关键词" clearable>
                     <el-button slot="append" style="color: #ffffff;" @click="searchCase()">搜索</el-button>
                  </el-input>
               </div>
            </div>
         </div>
         <div class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="caseData" highlight-current-row v-loading="loadingEvalCase" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="title" align="center" label="案件名称" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="area" align="center" label="案件领域" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="caseStatus" align="center" label="案件状态" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.caseStatus == 1">待支付</span>
                     <span v-if="scope.row.caseStatus == 2 || scope.row.caseStatus == 3 || scope.row.caseStatus == 4">智能评测中</span>
                     <span v-if="scope.row.caseStatus == 5">专家评测中</span>
                     <span v-if="scope.row.caseStatus == 6">报告生成中</span>
                     <span v-if="scope.row.caseStatus == 7">报告已生成</span>
                  </template>
               </el-table-column>
               <el-table-column prop="type" align="center" label="案件类型" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="name" align="center" label="专家姓名" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="mobile" align="center" label="专家手机号" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="agentStatus" align="center" label="专家状态" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span style="color: #999999;cursor: pointer;" v-if="scope.row.agentStatus==1">禁用</span>
                     <span style="color: #407AA8;cursor: pointer;" v-if="scope.row.agentStatus==2">正常</span>
                     <span style="color: #F56C6C;cursor: pointer;" v-if="scope.row.agentStatus==3">待审核</span>
                  </template>
               </el-table-column>
               <el-table-column prop="complete_time" align="center" label="完成时间" width="120" show-overflow-tooltip>
               </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparmEval" @callFather="callFatherEval"></Pagination>
         </div>
      </div>
      <!-- 修改密码 -->
      <div class="edit-password">
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editPsdVisible" width="400px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">{{ title }}</div>
            <el-form :model="passwordForm" style="margin-top: 30px;">
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>新密码</div>
                  <el-input size="small" auto-complete="off" type="password" class="invocie-input" v-model.trim="passwordForm.password" clearable></el-input>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>重复密码</div>
                  <el-input size="small" auto-complete="off" type="password" class="invocie-input" v-model.trim="passwordForm.passwords" clearable></el-input>
               </div>
               <el-button style="width: 100%;margin-top: 20px;" type="primary" @click="commitPassword()">确认修改</el-button>
            </el-form>
         </el-dialog>
      </div>
      <!-- 新增账户 -->
      <div class="edit-customer">
            <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editAgentVisible" width="400px">
               <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">{{ title }}</div>
               <el-form :model="agentForm" style="margin-top: 30px;">
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="name"><span style="color: #F56C6C;padding-right: 2px;margin-left: -6px;">*</span>姓名</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="agentForm.name" placeholder="请填写姓名" clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="mobile"><span style="color: #F56C6C;padding-right: 2px;margin-left: -6px;">*</span>账户(手机号)</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="agentForm.mobile" placeholder="请填写手机号" clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;"><span style="color: #F56C6C;padding-right: 2px;margin-left: -6px;">*</span>领域</div>
                     <el-select v-model="agentForm.area" placeholder="请选择领域" style="width: 100%;margin-top: 4px;" filterable clearable>
                        <el-option
                           v-for="item in areaData"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
                     </el-select>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;"><span style="color: #F56C6C;padding-right: 2px;margin-left: -6px;">*</span>所属机构</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="agentForm.agency_name" placeholder="请填写所属机构" disabled clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">邮箱</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="agentForm.email" placeholder="请填写邮箱" clearable></el-input>
                  </div>
                  <el-button style="width: 100%;margin-top: 20px;background-color: #2A91DD;" type="primary" @click="commitAgent()">确认添加</el-button>
               </el-form>
            </el-dialog>
      </div>
       <!-- 导入账户 -->
    </div>
 </template>
 <script>
   import { 
      changeAgentPassword,
      getAgentInfo,
      getAgentPageDataList,
      addAgentAccount,
      changeAgentStatus,
      getAgentCasePageList
   } from '../../api/evalMG'
   import md5 from 'js-md5'
   import Pagination from '../../components/Pagination'
   import topInfo from '../../components/topInfo'
   import agentNav from '../../components/agentNav'
   import { checkLogin } from '../../utils/util'
   export default {
      data() {
         return {
            loading: false,
            editPsdVisible: false,
            loadAccounting: false,
            loadingEvalCase: false,
            editAgentVisible: false,
            title: '',
            adminInfoForm: {
               id: '',
               name: '',
               mobile: '',
               email: '',
               area: '',
               company: '',
               position: ''
            },
            passwordForm: {
               password: '',
               passwords: ''
            },
            formInline: {
               page: 1,
               ps: 10,
               search: ''
            },
            evalOrderDate: [],
            formInlineCase: {
               page: 1,
               ps: 10,
               search: '',
               startDate: '',
               endDate: ''
            },
            agentForm: {
               id: '',
               name: '',
               mobile: '',
               email: '',
               agency_id: '',
               agency_name: '',
               position: '',
               area: '',
               status: ''
            },
            formInlineAccount: {
               page: 1,
               ps: 10,
               search: ''
            },
            formInlineEval: {
               page: 1,
               ps: 10,
               search: ''
            },
            areaData:[
               {
                  id: '机械',
                  name: '机械'
               },
               {
                  id: '电学',
                  name: '电学'
               },
               {
                  id: '通信',
                  name: '通信'
               },
               {
                  id: '生物',
                  name: '生物'
               },
               {
                  id: '光电',
                  name: '光电'
               },
               {
                  id: '化学',
                  name: '化学'
               },
               {
                  id: '材料',
                  name: '材料'
               }
            ],
            accountData: [],
            caseData: [],
            pickerOptions: {
               shortcuts: [{
               text: '最近一周',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
               picker.$emit('pick', [start, end]);
               }
            }, {
               text: '最近一个月',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
               picker.$emit('pick', [start, end]);
               }
            }, {
               text: '最近三个月',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
               picker.$emit('pick', [start, end]);
               }
            }]
            },
            // 分页参数
            pageparm: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            },
            pageparmAccount: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            },
            // 分页参数(案件订单)
            pageparmEval: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            },
         }
      },
      // 注册组件
      components: {
         Pagination,
         topInfo,
         agentNav
      },
      created(){
         this.getAdminInfoData()
      },
      methods: {
        // 跳转待评估案件
        jumpWait(){
            this.$router.push({ path: '/agent/waitEval'});
         },
         // 跳转专家撰写
         jumpWrite(){
            this.$message({
               type: 'warning',
               message: '请选择需要撰写的案件'
            })
            // this.$router.push({ path: '/agent/writeEval'});
         },
         // 跳转评估记录
         jumpEvalRecord(){
            this.$router.push({ path: '/agent/agentEvalRecord'});
         },
         // 跳转个人中心
         jumpPersonCenter(){
            this.$router.push({ path: '/agent/agentPersonCenter'});
         },

         // 显示修改密码弹窗
         showEditPsd(){
            this.editPsdVisible = true
            this.title = '修改密码'
         },
         // 提交密码修改
         commitPassword(){
            let password = this.passwordForm.password
            let passwords = this.passwordForm.passwords
            if(password.length <= 0 || passwords.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写必填项!'
               }) 
               return false
            }
            if(password != passwords){
               this.$message({
                  type: 'warning',
                  message: '两次输入密码不一致!'
               }) 
               return false
            }
            let param = {
               password: md5(password)
            }
            changeAgentPassword(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.editPsdVisible = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  }) 
                  return false
               }
            })
         },
         // 查询管理员账户基本信息
         getAdminInfoData(){
            let param = {}
            getAgentInfo(param)
            .then(res=>{
               res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                  this.adminInfoForm.name = res.data.name
                  this.adminInfoForm.mobile = res.data.mobile
                  this.adminInfoForm.agency_name = res.data.agency_name
                  this.adminInfoForm.id = res.data.id
                  this.adminInfoForm.area = res.data.area
                  this.adminInfoForm.email = res.data.email
                  this.adminInfoForm.position = res.data.position
                  this.adminInfoForm.status = res.data.status
                  if(res.data.position == '负责人' && res.data.status==2){
                     this.getAgentData()
                     this.getAgentCaseData()
                  }
               }
            })
         },
         // 查询专家列表
         getAgentData(){
            this.loadAccounting = true
            getAgentPageDataList(this.formInlineAccount)
            .then(res=>{
               if(res.code == 200){
                  this.accountData = res.data.dataList
                  this.pageparmAccount.currentPage = this.formInlineAccount.page
                  this.pageparmAccount.pageSize = this.formInlineAccount.ps
                  this.pageparmAccount.total = res.data.total
                  this.loadAccounting = false
               }else{
                  this.loadAccounting = false
               }
            })
         },
         // 显示新增专家界面
         showEditAgent(){
            let agency = this.adminInfoForm.agency_name 
            this.title = '新增专家'
            this.agentForm.name = ''
            this.agentForm.mobile = ''
            this.agentForm.area = ''
            this.agentForm.email = ''
            this.agentForm.agency_name = agency
            this.agentForm.position = '专家'
            this.agentForm.status = 3        
            this.editAgentVisible = true
         },
         searchAgent(){
            this.formInlineAccount.page
            this.getAgentData()
         },
         // 提交专家
         commitAgent(){
            let data = this.agentForm
            if(data.name.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写姓名'
               })
               return false
            }
            if(data.mobile.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写手机号'
               })
               return false
            }
            if(data.area.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请选择领域'
               })
               return false
            }
            let param = {
               name: data.name,
               mobile: data.mobile,
               area: data.area,
               position: data.position,
               status: data.status,
               email: data.email,
               agency_name: data.agency_name
            }
            addAgentAccount(param)
            .then(res=>{
               if(res.code==200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.editAgentVisible = false
                  this.getAgentData()
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
            console.log(data)
         },
         // 修改专家账户状态
         changeAgentStatus(row,status){
            let agentId = row.id
            let param = {
               agent_id: agentId,
               status: status
            }
            if(status == 1){
               // 禁用专家账户
               this.$confirm('确定要禁用此专家账户?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
               })
               .then(()=>{
                  changeAgentStatus(param)
                  .then(res=>{
                     if(res.code == 200){
                        this.$message({
                           type: 'success',
                           message: '专家账户已成功禁用!'
                        })
                        this.getAgentData()
                     }else{
                        this.$message({
                           type: 'error',
                           message: '专家账户已禁用失败,请稍后再试!'
                        })
                     }
                  })
               })
               .catch(() => {
                  this.$message({
                     type: 'info',
                     message: '已取消'
                  })
               })
            }
            if(status ==3){
               // 申请恢复专家账户
               this.$confirm('确定要恢复此专家账户?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
               })
               .then(()=>{
                  changeAgentStatus(param)
                  .then(res=>{
                     if(res.code == 200){
                        this.$message({
                           type: 'success',
                           message: '专家账户提交恢复申请!'
                        })
                        this.getAgentData()
                     }else{
                        this.$message({
                           type: 'error',
                           message: '恢复申请提交失败,请稍后再试!'
                        })
                     }
                  })
               })
               .catch(() => {
                  this.$message({
                     type: 'info',
                     message: '已取消'
                  })
               })
            }
         },
         // 查询案件列表
         getAgentCaseData(){
            this.loadingEvalCase = true
            let evalOrderDate = this.evalOrderDate
            if(evalOrderDate&&evalOrderDate.length>0){
               this.formInlineCase.startDate = evalOrderDate[0]
               this.formInlineCase.endDate = evalOrderDate[1]
            }else{
               this.formInlineCase.startDate = ''
               this.formInlineCase.endDate = ''
            }
            getAgentCasePageList(this.formInlineCase)
            .then(res=>{
               if(res.code == 200){
                  this.caseData = res.data.dataList
                  this.pageparmEval.currentPage = this.formInlineCase.page
                  this.pageparmEval.pageSize = this.formInlineCase.ps
                  this.pageparmEval.total = res.data.total
                  this.loadingEvalCase = false
               }else{
                  this.loadingEvalCase = false
               }
            })
         },
         // 点击搜索查询案件
         searchCase(){
            this.formInlineCase.page = 1
            this.getAgentCaseData()
         },
         // 清除案件订单日期
         clearEvalDate(){
            this.evalOrderDate = []
         },
         // 分页插件事件
         callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.ps = parm.pageSize
         },
         // 分页插件事件(账户)
         callFatherAccount(parm){
            this.formInlineAccount.page = parm.currentPage
            this.formInlineAccount.ps = parm.pageSize
            this.getAgentData()
         },
         // 分页插件事件(案件订单)
         callFatherEval(parm) {
            this.formInlineEval.page = parm.currentPage
            this.formInlineEval.ps = parm.pageSize
            this.getAgentCaseData()
         },
      }
   }
</script>
<style scoped>
  .login-page {
    text-align: center;
    /* height: 100%; */
  }
  .login-title {
    font-size: 44px;
    font-weight: 700;
    padding-top: 24px;
  }
  .login-title-en {
    font-size: 16px;
    color: #5a5a5a;
    margin-top: 10px;
  }
  .eval-content {
   width: 1200px;
   /* height: 600px; */
   margin: 0px auto;
   background-color: #fff;
   border-radius: 10px;
  }
  .eval-con-top {
   display: flex;
   margin: 10px 40px;
   padding: 16px 0px;
   border-bottom: 2px solid #eeeeee;
  }
  .eval-con-title {
   color: #2A91DD;
   height: 36px;
   line-height: 36px;
   font-size: 16px;
   font-weight: 700;
  }
  .eval-con-btn {
   width: 120px;
   height: 36px;
   line-height: 36px;
   text-align: center;
   color: #fff;
   background-color: #FF8B36;
   border-radius: 5px;
   margin-left: 20px;
   cursor: pointer;
  }
  .eval-con-search {
   margin-left: 20px;
  }
  .eval-con-search>>>.el-input-group {
   border-radius: 10px !important;
  }
  .eval-con-search>>>.el-input-group__append, .el-input-group__prepend {
   color: #FFFFFF;
   background-color: #2A91DD;
   cursor: pointer;
  }
  .eval-con-search>>>.el-input__inner {
   background-color: #F3F3F3 !important;
   border: none;
  }
  .eval-table {
   width: 1120px;
   margin: 0px auto;
  }
  .eval-table>>> .el-table__header th {
   background-color: #2A91DD !important;
  }
  .eval-table>>> .el-table thead {
   color: #FFFFFF;
  }

  .eval-form {
   width: 1120px;
   margin: 0px auto;
  }
  .eval-form>>>.el-form-item__label {
   text-align: left !important;
   font-weight: 700 !important;
   padding-left: 10px !important;
  }
  .eval-form>>> .el-input__inner {
   background-color: #F3F3F3 !important;
  }
  .eval-form>>> .el-textarea__inner {
   background-color: #F3F3F3 !important;
   min-height: 80px !important;
  }
  .invoice-item {
   display: flex;
   width: 1120px;
   margin: 0px auto;
   margin-bottom: 20px;
  }
  .invoice-type {
   height: 40px;
   line-height: 40px;
   font-weight: 700;
   color: #FFFFFF;
   background-color: #2A91DD;
   border-radius: 4px;
   padding: 0px 10px;
   font-size: 12px;
  }
  .invoice-label {
   margin-left: 40px;
   height: 40px;
   line-height: 40px;
   font-weight: 700;
   font-size: 12px;
  }
  .invoice-text {
   margin-left: 20px;
   text-align: left;
   height: 40px;
   line-height: 40px;
   background-color: #F3F3F3;
   padding-left: 20px;
   color: #666666;
   border-radius: 4px;
   font-size: 12px;
  }
  /* .edit-invoice>>> .el-dialog__header{
   display: none !important;
  }   */

  .invocie-input{
   background-color: #ECEDF4;
   margin-top: 4px;
  }
  .invoice-btn {
   background-color: #ECEDF4;
   padding: 4px 10px;
   border-radius: 50px;
   width: 50%;
   cursor: pointer;
  }
  .invoice-btn-active {
   background-color: #2A91DD;
   color: #FFFFFF;
  }
  .eval-content {
   width: 1200px;
   /* height: 600px; */
   margin: 0px auto;
   background-color: #fff;
   border-radius: 10px;
  }
  .eval-con-top {
   display: flex;
   margin: 10px 40px;
   padding: 16px 0px;
   border-bottom: 2px solid #eeeeee;
  }
  .eval-con-title {
   color: #2A91DD;
   height: 36px;
   line-height: 36px;
   font-size: 16px;
   font-weight: 700;
  }
  .eval-con-btn {
   width: 120px;
   height: 40px;
   line-height: 40px;
   text-align: center;
   color: #fff;
   background-color: #FF8B36;
   border-radius: 5px;
   margin-left: 20px;
   cursor: pointer;
  }
  .eval-con-search {
   margin-left: 20px;
  }
  .title-flex-end {
   display: flex;
   justify-content: flex-end;
   margin-left: auto;
 }
 .areaPicker {
   margin-top: 2px;
   margin-right: 20px;
 }
 .areaPicker>>>.el-input__inner {
    width: 210px !important;
    height: 40px !important;
    line-height: 40px !important;
    margin-top: -4px !important;
    padding-top: 3px !important;
    padding-bottom: 3px !important;
    padding-left: 20px !important;
    padding-right: 0px !important;
}
.areaPicker>>>i {
    display: none !important;
}
.areaPicker>>>.el-date-editor .el-range-separator {
    line-height: 30px !important;
    color: #999999 !important;
}
.clearBtn {
   padding: 12px 10px;
   border: 1px solid #2A91DD;
   border-radius: 4px;
   color: #ffffff;
   background-color: #2A91DD;
   font-size: 12px;
   cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/agent/agentPersonCenter.vue